import SideCart from "./SideCart";
import MainCart from "./MainCart";
customElements.define('side-cart', SideCart);
customElements.define('main-cart', MainCart);

const cart = document.querySelector<SideCart>('side-cart');
const cartButton = document.querySelector<HTMLButtonElement | HTMLAnchorElement>('#side-cart-button');

function handleCartButtonClick(event: Event) {
    event.preventDefault(); // Prevents default behavior in case it's a link

    if (cart && typeof cart.open === 'function') {
        cart.open('button');
    } else {
        console.error('The open method does not exist on the <side-cart> element.');
    }
}

if (!cart) {
    console.error('The <side-cart> element could not be found.');
}

if (!cartButton) {
    console.error('The button/anchor with id #side-cart-button could not be found.');
} else {
    cartButton.addEventListener('click', handleCartButtonClick);
}